import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Fruit from '../components/Fruit'
import Mdm from '../components/Mdm'
import Risk from '../components/Risk'
import Fashion from '../components/Fashion'
import Applica from '../components/Applica'
import Applet from '../components/Applet'
import Aboutus from '../components/Aboutus'
import Contactus from '../components/Contactus'
import Login from '../components/Login'
import Register from '../components/Register'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        // {
        //     path: '/risk',
        //     name: 'Risk',
        //     component: Risk
        // },
        {
            path: '/mdm',
            name: 'Mdm',
            component: Mdm
        },
        {
            path: '/applet',
            name: 'Applet',
            component: Applet
        },
        {
            path: '/contactus',
            name: 'Contactus',
            component: Contactus
        },
        {
            path: '/aboutus',
            name: 'Aboutus',
            component: Aboutus
        },
        {
            path: '/applica',
            name: 'Applica',
            component: Applica
        },
        {
            path: '/fruit',
            name: 'Fruit',
            component: Fruit
        },
        {
            path: '/fashion',
            name: 'Fashion',
            component: Fashion
        },
    ]
})
